/* =====================================================================
   ap-countdown.js — THE giveaway countdown. Single config, many consumers.
   Vektor, 2026-07-30 (s51).

   WHY THIS FILE EXISTS: the countdown used to live inline in the
   /pages/giveaway body. Building the 404 (Charles, Slack 1785380890) meant a
   second one — and Maya's engineering note is the right one: two countdowns
   disagree the moment one gets the rally date and the other doesn't, and the
   one nobody remembers is the one on the error page. So the config lives HERE,
   once, and every consumer is driven from it.

   ===== TO START THE TIMER, EDIT THESE THREE LINES AND NOTHING ELSE =====
   STARTED 2026-08-05 (s75). The two dates, and why they are two:

     Entries close  Thursday 13 May 2027   <- THIS is what END counts down to
     Drawing        Friday   14 May 2027   <- the event on top of it

   Charles, Slack 1785963850: "entry-close are the Thursday before all
   giveaways which will have hard dates for Fridays ONLY." He had already
   given 14 May 2027 as the giveaway's date, and 14 May 2027 IS a Friday —
   the rule and the date corroborate each other, which is the only reason
   this was safe to set from a message addressed to someone else.

   THE LABEL IS WHY THIS COUNTS TO THE 13th AND NOT THE 14th. init() sets the
   running label to "Giveaway Ends In". Entries end on the Thursday; the draw
   is a day later. Pointing an "ends in" clock at the draw date would publish
   an extra day of entry period that does not exist. If you ever repoint END
   at the draw, change the label in init() in the same edit.

   THE HOUR IS MINE, NOT HIS, AND IT IS THE ONE SOFT NUMBER HERE. Charles gave
   a DAY. 23:59:59 is the plain reading of "entries close Thursday" and is the
   generous direction (it cannot cut anyone's entry short). Raised with him in
   Slack the same day; it is a one-line change if he wants another hour.

   SUPERSEDED, do not re-derive it: the old note here said the draw waited on
   the 2027 Black Wall Street Rally publishing its dates in AUGUST 2026. It is
   August 2026 now and that sentence had started to read as a broken promise
   on two live surfaces. Charles's hard date replaces it. The draw is still
   live at the rally (Slack 1785348374) — that is the venue, not the date.

   Never publish a countdown to an unconfirmed date, and never let a paused
   countdown read as an ended one — that was the live defect this whole
   mechanism came out of.
   THE OFFSET IS NOT OPTIONAL, AND LEAVING IT OFF IS NOT "UNDECIDED". A date-time string with
   no offset is parsed as the VISITOR'S OWN LOCAL TIME, so the clock ended at a different
   moment for every entrant: a Hawaii visitor's hit zero five hours AFTER Central close, a Guam
   visitor's FIFTEEN HOURS BEFORE it -- telling them entries were shut while they were still
   open. Charles pays freight to AK, HI and the territories precisely so those entrants count.
   Maya found it 2026-08-07; fixed the same day to -05:00 (US Central, CDT in May).
   An unset spec term does not leave a blank in a running system -- it leaves a DEFAULT, and
   "whatever the reader's laptop says" is the one answer no published rule can ever match.
   The controlling time zone is still listed as Pending on /pages/sweepstakes-rules; that is a
   rules question for the sweepstakes administrator, and this line is the code half of it.
   Format "YYYY-MM-DDTHH:MM:SS±HH:MM".
   ===================================================================== */
window.AP_COUNTDOWN = {
  PAUSED: false, // true => no clock; every consumer shows its "to be announced" panel
  START: '', // optional, e.g. "2026-08-15T00:00:00" — before it, the clock reads zero
  END: '2027-05-13T23:59:59-05:00', // ENTRIES CLOSE, US CENTRAL. Draw is the next day; see above.
};

/* ---------------------------------------------------------------------
   MARKUP CONTRACT — what a consumer has to provide.

   <div data-ap-countdown>                       <- the root
     <p  data-ap-cd-label>Drawing Date</p>       <- label, text is set by JS
     <div data-ap-cd-timer> … <span data-ap-cd="d">00</span> … </div>
     <div data-ap-cd-tba> … the to-be-announced panel … </div>
   </div>

   Digit keys: d h m s. All four optional; a missing one is skipped.

   FAIL-SAFE, AND IT IS LOAD-BEARING: a consumer's CSS must show the TBA panel
   and hide the clock BY DEFAULT, and reveal the clock only under
   `.ap-cd--running` on the root. If this file fails to load, the visitor then
   sees the correct "to be announced" state rather than a zeroed clock reading
   as a giveaway that already ended — which is exactly the defect Charles
   reported on 2026-07-29. Never invert that default.
   --------------------------------------------------------------------- */
(function () {
  var CFG = window.AP_COUNTDOWN || {};

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init() {
    var roots = document.querySelectorAll('[data-ap-countdown]');
    if (!roots.length) return;

    var end = CFG.END ? new Date(CFG.END).getTime() : NaN;
    var start = CFG.START ? new Date(CFG.START).getTime() : null;
    var running = !CFG.PAUSED && !!CFG.END && !isNaN(end);

    Array.prototype.forEach.call(roots, function (root) {
      root.classList.toggle('ap-cd--running', running);
      var label = root.querySelector('[data-ap-cd-label]');
      if (label) label.textContent = running ? 'Giveaway Ends In' : 'Drawing Date';
    });

    if (!running) return; // digits stay at their markup zeros; the TBA panel is what shows

    function paint(d, h, m, s) {
      Array.prototype.forEach.call(roots, function (root) {
        var map = { d: d, h: h, m: m, s: s };
        Object.keys(map).forEach(function (k) {
          var el = root.querySelector('[data-ap-cd="' + k + '"]');
          if (el) el.textContent = pad(map[k]);
        });
      });
    }

    function tick() {
      var now = Date.now();
      if ((start && !isNaN(start) && now < start) || now >= end) {
        paint(0, 0, 0, 0);
        return;
      }
      var diff = Math.floor((end - now) / 1000);
      var d = Math.floor(diff / 86400);
      diff -= d * 86400;
      var h = Math.floor(diff / 3600);
      diff -= h * 3600;
      var m = Math.floor(diff / 60);
      paint(d, h, m, diff - m * 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
